import { getIsChatSetup } from '../../verify-install/selectors/getIsChatSetup';
import { getIsEmailSetup } from '../../verify-install/selectors/getIsEmailSetup';
import { getIsFacebookMessengerSetup } from '../../verify-install/selectors/getIsFacebookMessengerSetup';
import { getIsFormsSetup } from '../../verify-install/selectors/getIsFormsSetup';
// TODO: when zero-state supports WhatsApp, add in a check for it

export const getShowAgentStatus = state => {
  return Boolean(getIsChatSetup(state) || getIsEmailSetup(state) || getIsFacebookMessengerSetup(state) || getIsFormsSetup(state));
};